import type { TOC } from '@ember/component/template-only';
import ActionItemTemplate from 'garaje/components/homepage/kiosk-demo/pages/templates/action-item-template';
import PageTemplate from 'garaje/components/homepage/kiosk-demo/pages/templates/page-template';
import type { KioskDemoPage } from 'garaje/components/homepage/kiosk-demo/provider';

interface VisitorsRecognitionPageSignature {
  Args: KioskDemoPage;
}

export default <template>
  <PageTemplate
    @headerTitle="Visitors Recognition"
    @headerInfo="Visitors typically start by typing in their name"
    @currentStep={{@currentStep}}
    @totalStepCount={{@totalStepCount}}
    @demoName={{@demoName}}
    @isUserLoggedIn={{@isUserLoggedIn}}
    @isDemoInstance={{@isDemoInstance}}
  >
    <div>
      <ActionItemTemplate
        @header="Manage returning visitors"
        @headerInfo="Envoy will recognize visitors who have signed in at your location before"
        @subHeader="Available on all plans"
        @iconLink="/assets/images/ipad-demo/icons/redo.svg"
        @iconAlt="Image of visitors"
        @pageLink="/visitors/settings/welcome-screen/returning-visitors"
        @isUserLoggedIn={{@isUserLoggedIn}}
        @demoName={{@demoName}}
        @isDemoInstance={{@isDemoInstance}}
      />
    </div>
  </PageTemplate>
</template> satisfies TOC<VisitorsRecognitionPageSignature>;
